'use es6';

import { useUpgradeEventListener } from 'ui-addon-upgrades/ums/useUpgradeEventListener';
export default function UpgradeEventListener() {
  useUpgradeEventListener();
  return null;
}